module.exports = __webpack_public_path__ + "static/media/completed.f7cf5ff7.png";